export default __webpack_public_path__ + "static/media/mintkeeper.8110fbd5.jpg";